import { object, string, number, date, InferType } from 'yup';
import { validations } from "./helpers/validations";
import { runValidation, runValidationOnBlur } from "./helpers/validationfunction";
import Dropzone from "dropzone";
import { initAccordions } from './accordions';

initAccordions()

document.addEventListener("DOMContentLoaded", () => {

    console.log("DOM fully loaded and parsed");

    const myForm = document.querySelector("#my-form");
    if (!myForm) return;
    const submitBtn = myForm.querySelector("button[type='submit']");
    const formfields = {
        name: myForm.querySelector("#name"),
        phone: myForm.querySelector("#phone"),
        email: myForm.querySelector("#email"),
        message: myForm.querySelector("#message"),
    }

    const schema = object({
        name: validations.text.required,
        phone: validations.phone,
        email: validations.email,
        message: validations.message.required,
    });

    const validationObject = () => {
        const validationObject = {
            name: formfields.name.value,
            email: formfields.email.value,
            phone: formfields.phone.value,
            message: formfields.message.value,
        };
        return validationObject;
    };

    // In this function you add the code you want to run when the form passes the validations and is ready for submition.
    function successSubmit(values) {
        submitBtn.classList.add("sending")

        console.log('form sucess', values)

        const submitObject = {
            FullName: values.name,
            Email: values.email,
            Phone: values.phone,
            Message: values.message,
        }
        console.log('form success', submitObject);

        const tokenElement = document.getElementsByName("__RequestVerificationToken")[0];
        const token = tokenElement ? tokenElement.value : null;

        const headers = {
            'Content-Type': 'application/json; charset=utf-8',
        };
        if (token) {
            headers['RequestVerificationToken'] = token;
        }

        fetch('/Umbraco/Surface/Contact/SubmitContact', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(submitObject)
        })
            .then(response => {
                submitBtn.classList.remove("sending")
                if (!response.ok) {
                    throw new Error(response.message || 'Something went wrong');
                }
                return response.json();
            })
            .then(result => {
                submitBtn.classList.remove("sending")
                setTimeout(() => {
                    const respEl = document.querySelector('#submit-response');
                    if (respEl) respEl.innerHTML = result.message;
                }, 1000);
            })
            .catch(error => {
                submitBtn.classList.remove("sending")
                console.error('Error:', error);
                const respEl = document.querySelector('#submit-response');
                if (respEl) respEl.innerHTML = error.message;
            });
    }

    // This two functions run the validations the one on submit and the other on blur.
    runValidation(myForm, formfields, validationObject, schema, successSubmit)
    runValidationOnBlur(myForm, formfields, validationObject, schema)
});

